import { NetworkStatus } from '@cbridge-utils/network';
import { IPerformanceMetricsStore } from './performanceMetrics.interface';

export const PERFORMANCE_METRICS_POLLING_INTERVAL = 5000;

export const performanceMetricsInitialState: IPerformanceMetricsStore = {
  data: {
    servers: [],
    lps: [],
  },
  networkStatus: NetworkStatus.None,
};
